import PolicyTypeTab from "./PolicyTypeTab";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../ContextApi";
import TabLoader from "../components/TabLoader";
import 'aos/dist/aos.css'; // Import AOS styles
import DashboardPolicyTypeTab from "./DashboardPolicyTypeTab";

const DashboardTabs = ({ scrollToSectionRef }) => {
    const {
        istabLoading, tabapiData
    } = useContext(AppContext);

    return (
        <>

            {istabLoading ? (
                <div className="tab_loadermain-wrapper">
                    <TabLoader />
                </div>
            ) : (
                tabapiData.map((tabdata, ind) => (
                    <>
                        <div className="col-lg-4">
                            <DashboardPolicyTypeTab
                                key={ind}
                                Tabicon={tabdata.logo}
                                fullName={tabdata.full_name}
                                policytypename={tabdata.policy_type_name}
                                policy_id={tabdata.policy_id}
                                policy_type_id={tabdata.policy_type_id}
                                intimateClaimvisibiltyData={tabdata.intimate_claim_visibility}
                                isTabDisabled={true}
                                scrollToSectionRef={scrollToSectionRef}
                                policyVisiblity={tabdata?.policy_visibility}
                            />
                        </div>


                    </>
                ))
            )}

        </>
    );
};

export default DashboardTabs;
